// Simple helper to auto click something during design process
const autoLinks = document.querySelectorAll('[data-auto-open]')
if (autoLinks) {
  autoLinks.forEach((link) => {
    link.click(link, 'click')
  })
}
